import { type FC, type ReactNode, useState } from "react";

import { clsx } from "clsx";

import { faChevronRight } from "@fortawesome/pro-duotone-svg-icons/faChevronRight";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const Dot: FC = () => (
  <span aria-hidden className="size-1.5 shrink-0 rounded-full bg-amber-500" />
);

// A drafted section's citations of sources it doesn't read, under its line in
// the sections list: an amber dot and `text`; with `list` (more than one), ›
// opens it under the line.
export const CitationLine: FC<{
  text: ReactNode;
  list?: ReactNode;
}> = ({ text, list }) => {
  const [open, setOpen] = useState(false);

  return (
    <div className="px-3 pb-1.5 text-[11.5px] text-amber-800">
      {list ? (
        <button
          type="button"
          aria-expanded={open}
          onClick={() => setOpen((prev) => !prev)}
          className="flex items-center gap-1.5 text-left"
        >
          <Dot />
          {text}
          <FontAwesomeIcon
            icon={faChevronRight}
            className={clsx("size-2.5", open && "rotate-90")}
          />
        </button>
      ) : (
        <p className="flex items-center gap-1.5">
          <Dot />
          <span>{text}</span>
        </p>
      )}
      {open && list && <p className="mt-0.5 pl-3">{list}</p>}
    </div>
  );
};
